export const DOMAIN = 'https://storage.googleapis.com';

export const FILE_EXTENSIONS = ['.tar', '.zip'];

export const URL_VALIDATION_STRING = '/dicomweb/';
